var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-message-box" }, [
    _c("img", {
      staticClass: "boss-message-box-avatar",
      attrs: { src: require("@/assets/images/avatar-company.svg") },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "boss-message-header-layout" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-layout-block boss-message-when",
          attrs: { "data-test": "date" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm._f("formatDateTime")(_vm.date)) + "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "boss-layout-block boss-message-recruit-title pega-primary-color-important",
        attrs: { "data-test": "job" },
      },
      [
        _vm._v("\n    求人ID：" + _vm._s(_vm.job.id) + "\n    "),
        _c("br"),
        _vm._v(_vm._s(_vm.job.name) + "\n  "),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "div",
        {
          staticClass: "boss-message-mail-subject",
          attrs: { "data-test": "subject" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm._f("formatSubject")(_vm.subject)) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "boss-message-mail-body pega-pre-wrap",
        attrs: { "data-test": "body" },
        domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "div",
        { staticClass: "boss-bonus-check-group" },
        [
          _vm._l(_vm.specialFavors, function (specialFavor, i) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.specialFavorBy(specialFavor.id).description,
                    },
                    expression:
                      "{ content: specialFavorBy(specialFavor.id).description}",
                  },
                ],
                key: i,
                staticClass: "boss-bonus-check-text pega-bonus-check-important",
                attrs: { "data-test": "special-favor-" + i },
              },
              [_vm._v(_vm._s(specialFavor.name))]
            )
          }),
          _vm._v(" "),
          _c("span", { attrs: { "data-test": "expiration-date" } }, [
            _vm._v(
              "（有効期限：" +
                _vm._s(_vm._f("formatDate")(_vm.expirationDate)) +
                "まで）"
            ),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "div",
        { staticClass: "boss-message-scouted pega-primary-color-important" },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/images/icon-scout.svg"),
              width: "16",
              alt: "",
            },
          }),
          _vm._v(" スカウト済み\n      "),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }